module.exports = __webpack_public_path__ + "static/img/securitybg2.aeed5b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/securitybg2.jpg
// module id = gYpa
// module chunks = 1